initalSetup()
eventSetup()

function initalSetup() {
  const menus = document.querySelectorAll('.swiper-menu')

  menus.forEach((menu) => {
    const currentTab = menu.querySelector('.active')
    if (currentTab === null) {
      return
    }
    const currentTabID = currentTab.querySelector('.swiper-tab').dataset.tabArea
    const tabContentArea = menu.closest('.section').querySelector('[data-tab-swiper="' + currentTabID + '"]')

    tabContentArea.classList.add('active-swiper')
  })
}

function eventSetup() {
  const tabs = document.querySelectorAll('.swiper-tabs-button')

  for (const tab of tabs) {
    tab.addEventListener('click', (event) => {
      event.preventDefault()
      const tabID = tab.querySelector('.swiper-tab').dataset.tabArea

      if (tab.classList.contains('active')) {
        return
      }

      //Remove active class on tabs
      const activeTabButton = document.querySelector('.swiper-tabs-button.active')
      const activeTabContent = document.querySelector('.active-swiper')

      //If we have an active button, remove the class
      if (activeTabButton !== null) {
        activeTabButton.classList.remove('active')
      }

      //If we have a active content area, remove the class
      if (activeTabContent !== null) {
        activeTabContent.classList.remove('active-swiper')
      }

      //Set active classes
      tab.classList.add('active')
      document.querySelector('[data-tab-swiper="' + tabID + '"]').classList.add('active-swiper')
    })
  }
}
